import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Subscription from './pages/Subscription';
import SubscriptionConfirmation from './pages/SubscriptionConfirmation';
import Contract from './pages/ContractPage';
import Payment from './pages/Payment';
import Success from './pages/Success';
import './styles/global.css';

const App: React.FC = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/subscription" element={<Subscription />} />
      <Route path="/subscription-confirmation" element={<SubscriptionConfirmation />} />
      <Route path="/contract" element={<Contract />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/success" element={<Success />} />
    </Routes>
  </Router>
);

export default App;
